<template>
    <div id="art">
     <div class="dokpz_left">
        <div class="title_left">{{ title }}</div>
	<div class="items">
     		<ejs-grid ref="grid" :dataSource="data" :allowPaging="true" :pageSettings="pageSettings" :allowSorting="true" :allowGrouping="false" :selectionSettings="selectionOptions" :rowSelected='rowSelected' :rowDeselected="rowSelected"> 
			<e-columns>
				<e-column field='ID_ARTYKULU' headerText='ID' :visible="false"></e-column>
				<e-column field='nazwaArtykulu' headerText='Nazwa artykułu' width='200'></e-column>
				<e-column field='jednostkaMiary' headerText='Jednostka miary' width='100'></e-column>
				<e-column field='OPIS' headerText='Opis' width='200'></e-column>
            			<!--<e-column type='checkbox' width='50'></e-column>-->
			</e-columns>
		</ejs-grid>
	</div>
      </div>
      <div class="dokpz_right">
	<div v-for="(item,index) in data" :key="index">
		<Skrzynia :nazwa="item.rodzaj_opakowania" :ident="index"/> 
	</div>
      </div>
      <div class="dokpz_right2">
     	<div v-show="czywaga">
		<button class="do_wagi"> PRZEJDŹ DO WAGI </button>
     	</div>
      </div>
      <div class="dokpz_bottom">
     	<div class="dok_pw">
		<button> LISTA DOKUMENTÓW PW </button>
     	</div>
       </div>
	<div class="wroc">
        	<button id="wroc"> WRÓĆ </button>
     	</div>
    </div>
</template>

<script>

import Vue from "vue";
import { GridPlugin, Page, Sort, Filter, Group } from "@syncfusion/ej2-vue-grids";
import { artykul_dane } from "./artykul_dane.js";
import Skrzynia from "@/components/Skrzynia";
import * as CONFIG from "./config.js";
import axios from "axios";
import Storage from "./Storage";

axios.defaults.withCredentials = false;

Vue.use(GridPlugin);
Vue.use(Skrzynia);

export default {
  name: "artykul",
  props: {
    groupTitle: String,
    dataLoading: Boolean,
  },
  data: () => ({
	//data: artykul_dane.items,
	data: [],
	url: "/agent/GALEK.Magazyn/GetArtykuly",
	title: "Panel główny > PRZYJĘCIE WYROBU GOTOWEGO",
	show: false,
        pageSettings: { pageSize: 5 },
        selectionOptions: { allowColumnSelection: false, type: 'Single' },
	czywaga: false,
	jwt: "",
   }),
   provide: {
	grid: [Page, Sort, Filter, Group]
   },
   methods: { 
	upclick() {
		try {
			document.querySelector(".e-prevpage").click();
		} catch (e) {}
	},
	downclick() {
		try {
			document.querySelector(".e-nextpage").click();
		} catch (e) {}
	},
	dowagiclick() {
		//alert("Przejdź do wagi");
		this.$router.push({ path: "/artykulwaga" });
	},
	dokpwclick() {
		//alert("Dokumenty PW");
		this.$router.push({ path: "/dokumentypw" });
	},
	wrocclick() {
		this.$router.push({ path: "/main" });
	},
	rowSelected(args) {
    		let selectedrowindex = this.$refs.grid.getSelectedRowIndexes();  // Get the selected row indexes.
    		//alert(selectedrowindex); // To alert the selected row indexes.
    		let selectedrecords = this.$refs.grid.getSelectedRecords();  // Get the selected records.
		//alert(selectedrecords);
		this.selectSkrzynia(selectedrowindex);
		console.log(selectedrowindex);
		if (selectedrowindex != null && selectedrowindex.length > 0) {
			this.show = true;
			this.czywaga = true;
		} else {
			this.show = false;
			this.czywaga = false;
		}
		
	},
	selectSkrzynia(val1) {
		this.$root.$emit("update:skrzynia", val1);
	},
	getData() {
                return axios
                        .get(CONFIG.API_URL + this.url, {
                        headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                                "Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
                        }
                        })
                        .then(response => {
                                return response.data;
                        })
                        .catch(e => {
                                alert("ERROR" + e);
                        });
        },
   },
   mounted() {
	var that = this;
	Storage.loadJWT("jwt").then(resp => {
                that.jwt = resp.access_token;
                that.getData().then(data => {
                        that.data = data;
                });
        });
	document.querySelector(".do_wagi").addEventListener('click', function() { that.dowagiclick(); } );
	document.querySelector(".wroc").addEventListener('click', function() { that.wrocclick(); } );
	document.querySelector(".dok_pw").addEventListener('click', function() { that.dokpwclick(); } );
   },
   components: {
	Skrzynia,
   }
};

</script>

<style>
  @import "../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";

.wroc {
	width: 100%;
	height: 10%;
	text-align: right;
	float: left;
}

.dok_pw {
	width: 100px;
	height: 50px;
	padding-top: 10px;
	text-align: left;
}

.do_wagi {
	width: 100px;
	height: 50px;
}

.title_left {
        text-align: left;
        width: 100%;
}
.items {
        float:none;
}
.dokpz_left {
        float: left;
        width: 50%;
        padding: 0% 2% 0% 2%;
}
.dokpz_right {
        padding: 10% 2% 0% 2%;
}
.dokpz_right2 {
        padding: 0% 2% 0% 2%;
}
.dokpz_right,.dokpz_right2 {
        float:right;
        width: 40%;

}
.dokpz_bottom {
        clear:both;
        width: 100%;
        padding: 2% 2% 0% 2%;
}
.wroc {
        width: 200px;
        height: 50px;
        position:relative;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        margin-left: 400px;
}
#wroc {
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/Artykul.vue